import { getUser } from "../user/selectors";

export const getUserKey = (state, key, userScope, sessionScope) => {
  if (userScope && sessionScope) {
    console.warn(
      `sessionScope is active for ${key}, userScope will be ignored.`
    );
  }
  const user = getUser(state);
  if (user.sessionId && sessionScope) {
    return `${user.sessionId.hashMe()}__${key}`;
  } else if (user.email && userScope) {
    return `${user.email.hashMe()}__${key}`;
  } else {
    return `__${key}`;
  }
};

export const getLocalStorageItemAsObject = key => {
  const currentStr = localStorage.getItem(key);
  return currentStr ? JSON.parse(currentStr) : {};
};

export const saveKeyValToLocalStorage = (key, val) => {
  const stringVal = typeof val === "object" ? JSON.stringify(val) : val;
  localStorage.setItem(key, stringVal);
};

export const safeSaveItemToLocalStorage = (key, val) => {
  try {
    return localStorage.setItem(key, val);
  } catch (e) {}
};

export const safeGetItemFromLocalStorage = key => {
  try {
    return localStorage.getItem(key);
  } catch (e) {}
};

export const safeRemoveItemFromLocalStorage = key => {
  try {
    return localStorage.removeItem(key);
  } catch (e) {}
};
